import createSvgIcon from '../Utils/CreateSvgIcon';

export const ArrowRight = createSvgIcon(
  <path
    clipRule="evenodd"
    d="M17.1707 13.0009L3 13L3.00012 11L17.1724 11.0009L10.3934 4.22183L11.8076 2.80762L21 12L11.8066 21.1934L10.3924 19.7791L17.1707 13.0009Z"
    fillRule="evenodd"
  />,
  'ArrowRight',
);
